import { useCallback, useLayoutEffect, useState } from 'react';

import { useAuthStore } from '@/features/auth/stores/useAuthStore';
import { AuthUser } from '@/features/auth/types/auth';
import { UserMarket } from '@/features/users/types/user';

import { useMarketStore } from '../stores/useMarketStore';
import { Market } from '../types/market';

export interface UseUserMarketRoles {
    getUserMarketRoles: (user: Pick<AuthUser, 'usersMarkets'> | null) => string;
    currentMarket?: Market;
    currentUserMarketRelation?: UserMarket;
}

export const useUserMarketRoles = (): UseUserMarketRoles => {
    const { authUser } = useAuthStore();
    const { market } = useMarketStore();

    const [currentMarket, setCurrentMarket] = useState<Market | undefined>();
    const [currentUserMarketRelation, setCurrentUserMarketRelation] = useState<UserMarket | undefined>();

    useLayoutEffect(() => {
        if (!authUser?.usersMarkets || !market?.id) {
            return;
        }

        const currentUserMarket = authUser.usersMarkets.find(({ market }) => market.id === market?.id);
        setCurrentUserMarketRelation(currentUserMarket);
        setCurrentMarket(currentUserMarket?.market);
    }, [market?.id, authUser?.usersMarkets]);

    const getUserMarketRoles = useCallback(
        (user: Pick<AuthUser, 'usersMarkets'> | null) => {
            if (!market?.id || !user) return '';

            const currentMarket = user.usersMarkets.find(({ market }) => market.id === market?.id);
            return currentMarket?.roles.map(({ name }) => name).join(', ') ?? '';
        },
        [market?.id],
    );

    return { getUserMarketRoles, currentMarket, currentUserMarketRelation };
};
